import React from "react";
import useProjects, { useCurrentProject } from "../hooks/useProjects";
import { ProjectSelectMenu } from "./ProjectSelectMenu";

interface Props {
  onChange: (projectId: string) => void;
  menuClassName?: string;
  buttonClassName?: string;
  listClassName?: string;
}
const ProjectSwitch: React.FC<Props> = ({
  onChange,
  menuClassName,
  buttonClassName,
  listClassName,
}) => {
  const { data: projects } = useProjects();
  const { project, setCurrentProjectId } = useCurrentProject();
  if (project === null || !project.id) {
    return null;
  }
  return (
    <ProjectSelectMenu
      value={project.id}
      menuClassName={menuClassName}
      buttonClassName={buttonClassName}
      listClassName={listClassName}
      projects={(projects ?? []).map((item) => ({
        id: item.id,
        name: item.name,
        propertyUrl: item.properties?.[0],
      }))}
      onChange={(projectId) => {
        setCurrentProjectId(projectId);
        onChange(projectId);
      }}
    />
  );
};
export { ProjectSwitch };
